import {
  all,
  put,
  takeLatest,
  call,
  delay,
  fork,
  take,
  race,
} from 'redux-saga/effects'
import { push } from 'connected-react-router'
import jwt_decode from 'jwt-decode'

import * as actionTypes from './action-types'
import * as actionTypesError from '../errors/action-types'
import {
  fetchUserInfo,
  storeAccessToken,
  fetchCompanyInfo,
  getStoredAccessToken,
  deleteStoredAccessToken,
  logout,
  logoutEndpoint,
  storeRefreshToken,
  deleteStoredRefreshToken,
  storeIdToken,
  getStoredIdToken,
  deleteStoredIdToken,
  updateUserActiveModule,
} from './api'

import keycloak, { initKeycloak } from './keycloak'
import { REFRESH_MARGIN_SECONDS } from './constants'
import { setIsConfigLoaded } from '../config/actions'

function* logoutSaga() {
  try {
    const storedToken = yield call(getStoredAccessToken)
    const storedIdToken = yield call(getStoredIdToken)
    const idToken = keycloak.idToken || storedIdToken
    console.log('ahora si,', idToken)
    const logoutRedirectUri = `${window.location.origin}/login`
    const keycloakLogoutUrl = new URL(
      keycloak.createLogoutUrl({
        redirectUri: logoutRedirectUri,
      }),
    )

    if (idToken) {
      keycloakLogoutUrl.searchParams.set('id_token_hint', idToken)
      keycloakLogoutUrl.searchParams.set(
        'post_logout_redirect_uri',
        logoutRedirectUri,
      )
    } else {
      keycloakLogoutUrl.searchParams.delete('post_logout_redirect_uri')
      keycloakLogoutUrl.searchParams.set('redirect_uri', logoutRedirectUri)
    }

    console.log('href', keycloakLogoutUrl.href)

    if (null !== storedToken) {
      try {
        yield call(logoutEndpoint, storedToken)
      } catch (e) {
        console.error('Error calling logout endpoint', e)
      }
    }

    console.log('href', keycloakLogoutUrl.href)
    yield call(logout)
    yield call(deleteStoredAccessToken)
    yield call(deleteStoredRefreshToken)
    yield call(deleteStoredIdToken)
    window.location.href = keycloakLogoutUrl.href
  } catch (e) {
    console.error('Error redirecting to Keycloak logout', e)
    yield call(logout)
    yield call(deleteStoredAccessToken)
    yield call(deleteStoredRefreshToken)
    yield call(deleteStoredIdToken)
    yield put(push('/login'))
  }
}

function* checkTokenSaga() {
  let authenticated = false
  try {
    authenticated = yield call(initKeycloak)
  } catch (e) {
    yield put(setIsConfigLoaded(true))
    return
  }

  try {
    if (!authenticated) {
      yield put(setIsConfigLoaded(true))
      return
    }

    const params = new URLSearchParams(window.location.search)
    if (params.get('activateModule') === 'true') {
      const { user_id } = jwt_decode(keycloak.token)
      yield call(updateUserActiveModule, user_id, keycloak.token)
      yield call([keycloak, 'updateToken'], -1)

      params.delete('activateModule')
      const search = params.toString()
      window.history.replaceState(
        {},
        '',
        `${window.location.pathname}${search ? `?${search}` : ''}${
          window.location.hash
        }`,
      )
    }

    const access_token = keycloak.token
    const refresh_token = keycloak.refreshToken
    const id_token = keycloak.idToken
    const accessTokenDecoded = jwt_decode(access_token)

    if (
      !accessTokenDecoded.active_module ||
      !accessTokenDecoded.active_module.id
    ) {
      yield call(logout)
      yield call(deleteStoredAccessToken)
      yield call(deleteStoredRefreshToken)
      yield put(setIsConfigLoaded(true))
      yield put(push('/'))
      return
    }

    if (accessTokenDecoded.active_module.id !== 'homologation') {
      window.location.href = `${accessTokenDecoded.active_module.login_url}`
      return
    }

    yield call(storeAccessToken, access_token)
    yield call(storeRefreshToken, refresh_token)
    if (id_token) {
      yield call(storeIdToken, id_token)
    }
    yield put({
      type: actionTypes.SET_TOKEN,
      payload: { access_token, refresh_token },
    })
    const { user_id } = jwt_decode(access_token)

    const userInfo = yield call(fetchUserInfo, user_id)
    const companyInfo = yield call(fetchCompanyInfo, userInfo.locale)
    yield put({
      type: actionTypes.SET_USER,
      payload: { ...userInfo, companyInfo },
    })
    yield fork(handleTokenSaga)
  } catch (e) {
    yield put(setIsConfigLoaded(true))
    yield put({ type: actionTypes.LOGOUT })
    yield put({ type: actionTypesError.ERROR, payload: { error: e } })
  }
}

function* handleTokenSaga() {
  while (true) {
    const { expired } = yield race({
      expired: delay(REFRESH_MARGIN_SECONDS),
      logout: take(actionTypes.LOGOUT),
    })

    if (!expired) {
      yield call(deleteStoredAccessToken)
      break
    }

    try {
      yield call([keycloak, 'updateToken'], REFRESH_MARGIN_SECONDS / 1000)
      yield call(storeAccessToken, keycloak.token)
      yield call(storeRefreshToken, keycloak.refreshToken)
      if (keycloak.idToken) {
        yield call(storeIdToken, keycloak.idToken)
      }
      yield put({
        type: actionTypes.SET_TOKEN,
        payload: {
          access_token: keycloak.token,
          refresh_token: keycloak.refreshToken,
        },
      })
    } catch (e) {
      yield put({ type: actionTypes.LOGOUT })
      yield put({ type: actionTypesError.ERROR, payload: { error: e } })
      break
    }
  }
}

function* checkActiveModuleSaga() {
  try {
    yield call([keycloak, 'updateToken'], 30)

    const accessTokenDecoded = jwt_decode(keycloak.token)
    const { active_module } = yield call(
      fetchUserInfo,
      accessTokenDecoded.user_id,
      keycloak.token,
    )

    if (active_module.id !== 'homologation') {
      window.location.href = active_module.login_url
    }
  } catch (e) {
    yield put({ type: actionTypesError.ERROR, payload: { error: e } })
  }
}

function* getUserInfoSaga({ payload: { userId } }) {
  const userInfo = yield call(fetchUserInfo, userId)
  const companyInfo = yield call(fetchCompanyInfo, userInfo.locale)
  yield put({
    type: actionTypes.SET_USER,
    payload: { ...userInfo, companyInfo },
  })
}

export default function* rootSaga() {
  yield all([
    takeLatest(actionTypes.LOGOUT, logoutSaga),
    takeLatest(actionTypes.GET_STORED_TOKEN, checkTokenSaga),
    takeLatest(actionTypes.CHECK_ACTIVE_MODULE, checkActiveModuleSaga),
    fork(checkTokenSaga),
    takeLatest(actionTypes.GET_USER_INFO, getUserInfoSaga),
  ])
}
